import { Component, ElementRef, ViewContainerRef, ValueProvider, Renderer2, Injector, ChangeDetectionStrategy, forwardRef, ContentChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ComponentBase, IComponentBase, applyMixins, ComponentMixins, PropertyCollectionInfo, FormBase, setValue } from '@syncfusion/ej2-angular-base';
import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { Template } from '@syncfusion/ej2-angular-base';


export const /** @type {?} */ inputs: string[] = ['actionFailureTemplate','allowFiltering','cssClass','dataSource','enablePersistence','enableRtl','enabled','fields','filterBarPlaceholder','filterType','floatLabelType','footerTemplate','groupTemplate','headerTemplate','htmlAttributes','ignoreAccent','ignoreCase','index','itemTemplate','locale','noRecordsTemplate','placeholder','popupHeight','popupWidth','query','readonly','showClearButton','sortOrder','text','value','valueTemplate','width','zIndex'];
export const /** @type {?} */ outputs: string[] = ['actionBegin','actionComplete','actionFailure','beforeOpen','blur','change','close','created','dataBound','destroyed','filtering','focus','open','select','valueChange'];
export const /** @type {?} */ twoWays: string[] = ['value'];
/**
 * The DropDownList component contains a list of predefined values, from which the user can choose a single value.
 * ```html
 * <ejs-dropdownlist></ejs-dropdownlist>
 * ```
 */
@ComponentMixins([ComponentBase, FormBase])
export class DropDownListComponent extends DropDownList implements IComponentBase {
public formCompContext : any;
public formContext : any;
public tagObjects: any;
public valueChange: any;
/**
 * Accepts the template design and assigns it to the footer container of the popup list. 
 * > For more details about the available template options refer to [`Template`](../../drop-down-list/templates) documentation.
 * \@default null
 */
@Template()
    public footerTemplate: any;
/**
 * Accepts the template design and assigns it to the header container of the popup list. 
 * > For more details about the available template options refer to [`Template`](../../drop-down-list/templates) documentation.
 * \@default null
 */
@Template()
    public headerTemplate: any;
/**
 * Accepts the template design and assigns it to the selected list item in the input element of the component. 
 * For more details about the available template options refer to 
 * [`Template`](../../drop-down-list/templates) documentation.
 * 
 * We have built-in `template engine`
 * which provides options to compile template string into a executable function.
 * For EX: We have expression evolution as like ES6 expression string literals.     
 * \@default null
 */
@Template()
    public valueTemplate: any;
/**
 * Accepts the template design and assigns it to the group headers present in the popup list.
 * \@default null
 * @deprecated
 */
@Template()
    public groupTemplate: any;
/**
 * Accepts the template design and assigns it to each list item present in the popup. 
 * We have built-in `template engine`
 * 
 * which provides options to compile template string into a executable function.
 * For EX: We have expression evolution as like ES6 expression string literals.     
 * \@default null
 * @deprecated
 */
@Template()
    public itemTemplate: any;
    
    @Template('No records found')
public noRecordsTemplate: any;
    
    @Template('Request failed')
public actionFailureTemplate: any;
private skipFromEvent:boolean = true;
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
        this.formContext  = new FormBase();
        this.formCompContext  = new ComponentBase();
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnChange(registerFunction: (_: any) => void): void {
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnTouched(registerFunction: () => void): void {
    }
/**
 * @param {?} value
 * @return {?}
 */
public writeValue(value: any): void {
    }
/**
 * @param {?} disabled
 * @return {?}
 */
public setDisabledState(disabled: boolean): void {
    }
/**
 * @return {?}
 */
public ngOnInit() {
        this.formCompContext.ngOnInit(this);
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
        this.formContext.ngAfterViewInit(this);
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
        this.formCompContext.ngOnDestroy(this);
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
        
        this.formCompContext.ngAfterContentChecked(this);
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ejs-dropdownlist',
    inputs: inputs,
    outputs: outputs,
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DropDownListComponent),
            multi: true
        }
    ],
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'footerTemplate': [{ type: ContentChild, args: ['footerTemplate', ] },],
'headerTemplate': [{ type: ContentChild, args: ['headerTemplate', ] },],
'valueTemplate': [{ type: ContentChild, args: ['valueTemplate', ] },],
'groupTemplate': [{ type: ContentChild, args: ['groupTemplate', ] },],
'itemTemplate': [{ type: ContentChild, args: ['itemTemplate', ] },],
'noRecordsTemplate': [{ type: ContentChild, args: ['noRecordsTemplate', ] },],
'actionFailureTemplate': [{ type: ContentChild, args: ['actionFailureTemplate', ] },],
};
}

function DropDownListComponent_tsickle_Closure_declarations() {
/** @type {?} */
DropDownListComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropDownListComponent.ctorParameters;
/** @type {?} */
DropDownListComponent.propDecorators;
/** @type {?} */
DropDownListComponent.prototype.formCompContext;
/** @type {?} */
DropDownListComponent.prototype.formContext;
/** @type {?} */
DropDownListComponent.prototype.tagObjects;
/** @type {?} */
DropDownListComponent.prototype.valueChange;
/**
 * Accepts the template design and assigns it to the footer container of the popup list. 
 * > For more details about the available template options refer to [`Template`](../../drop-down-list/templates) documentation.
 * \@default null
 * @type {?}
 */
DropDownListComponent.prototype.footerTemplate;
/**
 * Accepts the template design and assigns it to the header container of the popup list. 
 * > For more details about the available template options refer to [`Template`](../../drop-down-list/templates) documentation.
 * \@default null
 * @type {?}
 */
DropDownListComponent.prototype.headerTemplate;
/**
 * Accepts the template design and assigns it to the selected list item in the input element of the component. 
 * For more details about the available template options refer to 
 * [`Template`](../../drop-down-list/templates) documentation.
 * 
 * We have built-in `template engine`
 * which provides options to compile template string into a executable function.
 * For EX: We have expression evolution as like ES6 expression string literals.     
 * \@default null
 * @type {?}
 */
DropDownListComponent.prototype.valueTemplate;
/**
 * Accepts the template design and assigns it to the group headers present in the popup list.
 * \@default null
 * @deprecated
 * @type {?}
 */
DropDownListComponent.prototype.groupTemplate;
/**
 * Accepts the template design and assigns it to each list item present in the popup. 
 * We have built-in `template engine`
 * 
 * which provides options to compile template string into a executable function.
 * For EX: We have expression evolution as like ES6 expression string literals.     
 * \@default null
 * @deprecated
 * @type {?}
 */
DropDownListComponent.prototype.itemTemplate;
/** @type {?} */
DropDownListComponent.prototype.noRecordsTemplate;
/** @type {?} */
DropDownListComponent.prototype.actionFailureTemplate;
/** @type {?} */
DropDownListComponent.prototype.skipFromEvent;
/** @type {?} */
DropDownListComponent.prototype.registerEvents;
/** @type {?} */
DropDownListComponent.prototype.addTwoWay;
/** @type {?} */
DropDownListComponent.prototype.ngEle;
/** @type {?} */
DropDownListComponent.prototype.srenderer;
/** @type {?} */
DropDownListComponent.prototype.viewContainerRef;
/** @type {?} */
DropDownListComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
